import { render } from "./allschool.vue?vue&type=template&id=7779407e&scoped=true"
import script from "./allschool.vue?vue&type=script&lang=js"
export * from "./allschool.vue?vue&type=script&lang=js"

import "./allschool.vue?vue&type=style&index=0&id=7779407e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7779407e"]])

export default __exports__